import { queryOptions } from "@tanstack/react-query";

import { apiGet } from "@softmax/observatory-client/client";
import type { V2EpisodeDetail } from "@softmax/observatory-client/types";

export function episodeDetailQueryOptions(episodeId: string) {
  const elevatedPrivileges = false;
  return queryOptions({
    queryKey: [
      "episodes",
      "detail",
      episodeId,
      { elevatedPrivileges },
    ] as const,
    queryFn: ({ signal }) =>
      apiGet<V2EpisodeDetail>(`/v2/episodes/${encodeURIComponent(episodeId)}`, {
        elevatedPrivileges,
        signal,
      }),
    staleTime: 30000,
  });
}
